import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { ProjectKeyDetailsResponse } from "../../../api/services/project/model";
import { ProjectState } from "./model";

const initialState: ProjectState = {
  keyProjectDetails: null,
  isStartChildProgramNavigation: false,
  projectStatus: "",
  isEditable: false,
  areOpcoFieldsEditable: true,
};

const projectSlice = createSlice({
  name: "projectSlice",
  initialState,
  reducers: {
    saveKeyProjectDetails: (
      state,
      action: PayloadAction<ProjectKeyDetailsResponse>,
    ) => {
      const { projectStatus, ...rest } = action.payload;
      state.keyProjectDetails = rest;
      state.projectStatus = projectStatus;
    },
    startChildProgramNavigation: (state, action: PayloadAction<boolean>) => {
      state.isStartChildProgramNavigation = action.payload;
    },
    clearProjectDetails: (state) => {
      state.keyProjectDetails = null;
      state.projectStatus = "";
    },
    clearStartChildProgramNavigation: (state) => {
      state.isStartChildProgramNavigation = false;
    },
    updateProjectStatus: (state, action: PayloadAction<string>) => {
      state.projectStatus = action.payload;
    },
    updateProjectCountryPermission: (state, action: PayloadAction<boolean>) => {
      state.isEditable = action.payload;
    },
    updateProjectOpcoFieldsEditable: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.areOpcoFieldsEditable = action.payload;
    },
  },
});

export const {
  saveKeyProjectDetails,
  clearProjectDetails,
  startChildProgramNavigation,
  clearStartChildProgramNavigation,
  updateProjectStatus,
  updateProjectCountryPermission,
  updateProjectOpcoFieldsEditable,
} = projectSlice.actions;

export const persistProjectConfig = {
  version: 1,
  key: "mpg_next_admin_project_v1",
  storage,
  whitelist: [],
};

export default projectSlice.reducer;
